import React from 'react';
import {
  Row, Col, Button,
  Label, CustomInput
} from 'reactstrap';

const OrdenamientosConfig = ({ state, setState }) => {

  const updateField = (field, key, newVal) => {
    let Orders = [...state.Orders];
    Orders.forEach(f => {
      if (f.key === key) {
        f[field] = newVal;
      }
    });
    Orders = Orders.sort((a, b) => (a.orden - b.orden));
    Orders.forEach((item, index) => (item.orden = (index)));

    setState({ Orders: Orders });
  }

  return (
    <Row>
      {
        state.Orders.sort((a, b) => (a.orden - b.orden)).map((item, index) => (
          <Col xs={12} key={`order-${item.key}`}>
            <hr className='p-0 m-1' />
            <Row>
              <Col className="my-auto pr-0"><Label>{`${item.orden + 1}. ${item.nameToDisplay}`}</Label></Col>
              <Col xs={3} className="my-auto ml-auto">
                <CustomInput
                  type="checkbox"
                  id={`Order-${item.key}`}
                  label="Aplicar"
                  checked={item.enabled}
                  onClick={(evt) => {
                    evt.preventDefault();
                    setTimeout(() => updateField("enabled", item.key, !!!item.enabled), 100);
                  }}
                />
              </Col>
              <Col xs={4} className="my-auto">
                <Button color="primary" size="sm" onClick={() => updateField("orden", item.key, item.orden - 2)} className={index > 0 ? "mx-1 visible cursor-pointer" : "mx-1 invisible"}><i className="fa fa-arrow-up" aria-hidden="true"></i></Button>
                <Button color="primary" size="sm" onClick={() => updateField("orden", item.key, item.orden + 2)} className={index < (state.length - 1) ? "visible cursor-pointer" : "invisible"}><i className="fa fa-arrow-down" aria-hidden="true"></i></Button>
              </Col>
            </Row>
          </Col>
        ))
      }
    </Row>
  )
}

export default OrdenamientosConfig;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/OrdenamientosConfig.js